export enum ActivityStatus {
  Actioned = 'actioned',
  Unactioned = 'unactioned',
  UnactionedCritical = 'unactionedCritical',
  UnactionedNormalRisk = 'unactionedNormalRisk',
  Erroneous = 'erroneous',
}
